export enum STORY_TYPE {
  Audio = 1,
  Video = 2,
  Image = 3,
  Text = 4,
  Creation = 5
}
